import styled from "styled-components";

export const Container = styled.div`
  max-width: 1148px;
  width: 100%;
  margin: 0 auto;

  h1 {
    text-align: center;
    color: #fff;

    font-size: 20px;
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 768px) {
      margin: 0 10px;
    }

    .back {
      a {
        display: flex;
        align-items: center;
        width: 65px;
        background-color: #1487c9;
        padding: 10px 15px;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        border-radius: 20px;
        text-decoration: none;
        color: #fff;
      }
    }

    span {
      height: 70px;
      display: flex;
      align-items: center;

      border-bottom: 1px solid #1487c9;
    }
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;

    .project {
      background-color: #f5f5f5;
      padding: 10px;
      display: flex;
      flex-direction: column;
      min-height: 250px;

      img {
        width: 100%;
        min-height: 264px;
      }

      .detail {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 25px;

        strong,
        p {
          text-align: center;
        }

        strong {
          text-transform: uppercase;
          display: block;
          padding: 0;
          width: 100%;
          min-height: 40px;
          font-size: 15px;
        }
        p {
          display: block;
          padding: 0;
          width: 100%;
          min-height: 40px;
          font-size: 14px;
        }

        .province {
          background-color: #333;
          color: #fff;
          padding: 5px;
          margin-bottom: 15px;
        }
      }

      a.button {
        width: 146.98px;
        border: none;
        padding: 10px 15px;
        align-self: center;
        background-color: #1487c9;
        color: #fff;
        border-radius: 20px;
        font: 16px "Encode Sans Expanded";
        cursor: pointer;
        text-align: center;
        text-decoration: none;

        &:focus {
          outline: none;
        }
      }
    }

    @media screen and (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export const Main = styled.main`
  background: #333;
  background: linear-gradient(#0b7bc0, #000);
  padding: 40px 0;
`;

export const Post = styled.div`
  display: flex;
  flex-direction: row;
  background: #fff;

  .banner {
    display: block;
    width: 100px;

    p {
      padding: 0;
      width: 200px;
      font-size: 0.77rem;
      margin-bottom: 10px;
    }

    img {
      max-width: 740px;
      min-width: 200px;
      padding-bottom: 0;
      object-fit: cover;
    }
  }

  .banner-left {
    flex-direction: column;

    p {
      color: #000;
      text-align: center;
      font-weight: 400;
      font-size: 0.77rem;
      padding: 0 2rem 0 3rem;
    }
  }

  header {
    flex: 1;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      margin-top: 30px;
      margin-left: 14px;
    }
  }

  .h-6 {
    height: 760px;
  }

  section {
    flex: 2;

    padding: 30px;

    p {
      padding: 30px 0px 0px;
      line-height: 1.5;
    }

    a {
      display: inline-block;
      background: rgb(20, 135, 201);
      padding: 10px 25px;
      border-radius: 20px;
      color: rgb(255, 255, 255);
      text-decoration: none;
    }

    a:hover {
      opacity: 0.8;
    }
  }
`;
